import * as React from 'react';
import { flow, forEach } from 'lodash';
import { IStore } from '../../../../redux/IStore';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IQuoteActions } from '../../../../services/quote/models';
import { IAuthState } from '../../../../services/auth/models';
import * as queryString from 'query-string';

interface IRedirectHelperProps {
  auth: IAuthState;
  location: Location;
  actions: {
    quote: IQuoteActions;
    push: (route: string) => void;
    auth: IAuthActions;
  }
}

class RedirectHelper extends React.Component<IRedirectHelperProps> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions } = this.props;
    // Handle renewal redirect
    const renewalId = this.getRenewalId();
    if (renewalId && this.redirectToRenewal(renewalId)) {
      return;
    }

    const returnTo = this.getReturnTo() || '/account/summary';
    actions.push(returnTo);
  }

  private redirectToRenewal = (renewalId: string): boolean => {
    const { auth, actions } = this.props;

    let selectedQuote = null;
    forEach(auth.customer.renewals, (quoteSelected) => {
      if (renewalId === quoteSelected.id) {
        selectedQuote = quoteSelected;
      }
    });

    if (selectedQuote) {
      actions.quote.initRenewal(selectedQuote, this.getReturnTo());
      return true;
    }

    return false;
  }

  private getRenewalId = () => {
    const regex = this.getRegex().renewals;
    const match = regex.exec(this.getReturnTo());
    let renewalId = '';
    if (match) {
      renewalId = match[1];
    }

    return renewalId;
  }

  private getReturnTo = () => {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    return query.returnTo || '';
  }

  private getRegex = () => {
    return {
      renewals: /\/account\/renewals\/([\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12})/g,
    };
  }

  public render() {
    return null;
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(RedirectHelper);
